import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Compartilhe qualquer horário específico com seu paciente para agendar uma sessão na sua agenda. ", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "card mt-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Link gerado")
], -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "text-paragraph" }
const _hoisted_8 = { class: "d-flex gap-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-check-circle" }, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1)
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-whatsapp" }, null, -1)

import { useVeeField } from "@/composables/useVeeField";
import { sharedAppointmentSlotRepo } from "@/di/repositories";
import { shareScheduleSchema } from "@/schemas/shareSchedule";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toTypedSchema } from "@vee-validate/zod";
import { unformat } from "v-money3";
import { useForm } from "vee-validate";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareSchedule',
  setup(__props) {

const moneyConfig = {
  prefix: "R$ ",
  thousands: "",
  decimal: ",",
  precision: 2,
};

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);

const submitting = ref(false);
const link = ref("");
const linkCopied = ref(false);
const errorMessage = ref("");
// const formKey = ref(0);

const { handleSubmit, resetForm, setErrors } = useForm({
  validationSchema: toTypedSchema(shareScheduleSchema),
  initialValues: {
    date: "",
    time: "",
    value: session.value?.appointment_price,
  },
});

const dateModel = useVeeField("date");
const timeModel = useVeeField("time");
const valueModel = useVeeField("value");

const whatsappShareLink = computed(() => {
  const message = encodeURIComponent(
    `Olá! Segue o link para agendar sua sessão comigo: ${link.value}`,
  );
  return `https://wa.me/?text=${message}`;
});

const submit = handleSubmit(async (formValues) => {
  try {
    errorMessage.value = "";
    submitting.value = true;
    const slot = await sharedAppointmentSlotRepo.createSharedAppointmentSlot({
      date: `${formValues.date} ${formValues.time}:00`,
      value: formValues.value
        ? (unformat(String(formValues.value), moneyConfig) as number)
        : undefined,
    });
    link.value = slot.share_url;
    // resetForm();
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Link gerado",
      msg: "Um link com seu horário avulso foi gerado para você poder copiar e compartilhar",
    });
  } catch (error: any) {
    console.error(error);
    errorMessage.value = error?.message || "Não foi possível gerar o link";
  } finally {
    submitting.value = false;
  }
});

function copyLink() {
  if (link.value) {
    linkCopied.value = true;
    setTimeout(() => {
      linkCopied.value = false;
    }, 3000);
    navigator.clipboard.writeText(link.value);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_MoneyInput = _resolveComponent("MoneyInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_TextInput, {
      required: "",
      label: "Data da sessão",
      model: _unref(dateModel),
      type: "date",
      placeholder: "01/01/2000"
    }, null, 8, ["model"]),
    _createVNode(_component_TextInput, {
      required: "",
      label: "Horário de inicio da sessão",
      model: _unref(timeModel),
      type: "time",
      placeholder: "08:00"
    }, null, 8, ["model"]),
    _createVNode(_component_MoneyInput, {
      label: "Valor da sessão (opcional)",
      model: _unref(valueModel),
      placeholder: 
        session.value?.appointment_price
          ? `Padrão: R$ ${session.value.appointment_price}`
          : 'Deixe vazio para usar o valor padrão'
      ,
      errorMsg: _unref(valueModel).$errors[0]?.$message
    }, null, 8, ["model", "placeholder", "errorMsg"]),
    _createVNode(_component_FormButton, {
      label: "Gerar link",
      onOnClick: _unref(submit),
      loading: submitting.value
    }, null, 8, ["onOnClick", "loading"]),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (link.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(link.value), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-sm", {
              'btn-outline-primary': !linkCopied.value,
              'btn-success': linkCopied.value,
            }]),
                onClick: copyLink,
                disabled: linkCopied.value
              }, [
                (linkCopied.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(" Copiado ")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _hoisted_13,
                      _createTextVNode(" Copiar ")
                    ]))
              ], 10, _hoisted_9),
              _createElementVNode("a", {
                class: "btn btn-sm btn-outline-success",
                href: whatsappShareLink.value,
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _hoisted_15,
                _createTextVNode(" Compartilhar via WhatsApp ")
              ], 8, _hoisted_14)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})